import { render } from "./testsuiteeditor.vue?vue&type=template&id=64595184&scoped=true"
import script from "./testsuiteeditor.vue?vue&type=script&lang=js"
export * from "./testsuiteeditor.vue?vue&type=script&lang=js"

import "./testsuiteeditor.vue?vue&type=style&index=0&id=64595184&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64595184"]])

export default __exports__